import { Paragraph } from "grommet";
import styled from "styled-components";

const FirstParagraph = styled(Paragraph)`
  margin-top: -0.8em;
`;

export default FirstParagraph;
